import { cva } from 'class-variance-authority';

export const wrapperClasses = cva(['rounded-lg-alt bg-white-50 border-charcoal-alpha-50 w-full'], {
  variants: {
    disabled: {
      true: ['opacity-60'],
      false: ['opacity-100']
    }
  },
  defaultVariants: {
    disabled: false
  }
});

export const searchResultsWrapperClasses = cva(['relative']);
export const searchResultsContainerClasses = cva(
  ['rounded-b-lg-alt bg-white-50 absolute top-[-10px] left-[-1px] z-[var(--z-dialog)]'],
  {
    variants: {
      showResults: {
        true: [
          'border-l-charcoal-alpha-50 border-r-charcoal-alpha-50 border-b-charcoal-alpha-50 block border border-solid border-t-transparent'
        ],
        false: ['hidden']
      }
    },
    defaultVariants: {
      showResults: false
    }
  }
);

export const dividerClasses = cva(['border-charcoal-alpha-50 border-b-solid m-4 h-[1px] border-b']);

export const searchResultsClasses = cva(['flex max-h-64 flex-col overflow-y-auto', '']);

export const searchResultsItemClasses = cva(['p-4'], {
  variants: {
    disabled: {
      true: [''],
      false: ['hover:bg-charcoal-alpha-50 active:bg-charcoal-alpha-50 cursor-pointer']
    }
  }
});
